<template>
  <div>
    <div class="modal fade" id="edit-program-modal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Program</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="updateProgram">
            <div class="modal-body">
              <div class="form-group">
                <label for="program_name">Program Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="program_name"
                  v-model="form.program_name"
                  required
                />
              </div>

              <div class="form-group">
                <label for="former_name">Former Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="former_name"
                  v-model="form.former_name"
                  placeholder="Optional"
                />
              </div>

              <div class="form-group">
                <label for="discipline_code">Discipline Code</label>
                <input
                  type="text"
                  class="form-control"
                  id="discipline_code"
                  v-model="form.discipline_code"
                  required
                />
              </div>

              <div class="form-group">
                <label for="level_code">Level Code</label>
                <input
                  type="text"
                  class="form-control"
                  id="level_code"
                  v-model="form.level_code"
                  required
                />
              </div>

              <div class="form-group">
                <label for="major">Major</label>
                <input
                  type="text"
                  class="form-control"
                  id="major"
                  v-model="form.major"
                  placeholder="Optional"
                />
              </div>

              <div class="form-group">
                <label for="major_discipline_code">Major Discipline Code</label>
                <input
                  type="text"
                  class="form-control"
                  id="major_discipline_code"
                  v-model="form.major_discipline_code"
                  placeholder="Optional"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button type="submit" class="btn btn-primary" :disabled="loading">
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                {{ loading ? "Saving..." : "Save Changes" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditProgramModal",
  data() {
    return {
      loading: false,
      form: {
        id: "",
        program_name: "",
        former_name: "",
        discipline_code: "",
        level_code: "",
        major: "",
        major_discipline_code: "",
      },
    };
  },
  methods: {
    open(program) {
      this.form.id = program.id;
      this.form.program_name = program.program_name;
      this.form.former_name = program.former_name || "";
      this.form.discipline_code = program.discipline_code;
      this.form.level_code = program.level_code;
      this.form.major = program.major || "";
      this.form.major_discipline_code = program.major_discipline_code || "";

      $("#edit-program-modal").modal("show");
    },

    updateProgram() {
      this.loading = true;

      axios
        .put(`/api/program/${this.form.id}`, this.form)
        .then((response) => {
          toastr.success(
            response.data.message || "Program updated successfully",
            "Success"
          );
          $("#edit-program-modal").modal("hide");

          // Use the returned program data or fall back to form data
          const updatedProgram = response.data.program || this.form;
          this.$emit("programUpdated", updatedProgram);
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message || "Failed to update program";
          toastr.error(errorMessage, "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      $("#edit-program-modal").modal("hide");
    },
  },
};
</script>
